import "../Categories.scss";

import { Col, Form, Row } from "react-bootstrap";
import { faAdd, faTags } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";

import AppButton from "../../../commons/buttons/AppButton";
import AppCard from "../../../commons/cards/AppCard";
import AppInput from "../../../commons/inputs/AppInput";
import AppLoading from "../../../commons/AppLoading";
import CategoryAPI from "../CategoryAPI";
import CompanyAPI from "../../company/CompanyAPI";
import ConfirmModal from "../../../commons/modal/ConfirmModal";
import CustomCard from "../../../commons/cards/Card";
import EmptyState from "../../../commons/EmptyState";
import FloatingButton from "../../../commons/buttons/FloatingButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import HallAppCenterContainer from "../../../commons/containers/HallAppCenterContainer";
import HallAppToast from "../../../commons/HallAppToast";
import MenuTitle from "../../../commons/menu/MenuTitle";
import ModalCategory from "./ModalCategory";
import PullToRefresh from "react-simple-pull-to-refresh";
import noImg from "../../../assets/images/no-img.jpg";
import { normalizeString } from "../../../commons/util/HallAppUtil";

function Categories() {
    const [showModalCategory, setShowModalCategory] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [categories, setCategories] = useState([]);
    const [categoriesTmp, setCategoriesTmp] = useState([]);
    const [categorySelected, setCategorySelected] = useState({});
    const [showModalDelete, setShowModalDelete] = useState(false);
    const [isLoadingModalDelete, setIsLoadingModalDelete] = useState(false);

    const categoryAPI = new CategoryAPI();
    const companyAPI = new CompanyAPI();

    useEffect(() => {
        findAllCategories();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const findAllCategories = async () => {
        try {
            setIsLoading(true);
            const response = await categoryAPI.findAllByCompanyId(companyAPI.getCompanyManagment().id);
            const list = response.data || [];

            list.sort((a, b) => (a?.name || "").localeCompare(b?.name || ""));

            setCategories(list);
            setCategoriesTmp(list);
        } catch (_) {
            HallAppToast.genericError();
        } finally {
            setIsLoading(false);
        }
    };

    function search(value) {
        const normalizedValue = normalizeString(value);

        const results = categories.filter((cat) => {
            const normalizedName = normalizeString(cat?.name || "");
            return normalizedName.includes(normalizedValue);
        });

        setCategoriesTmp(results);
    }

    async function executeDeletion() {
        if (!categorySelected?.id) return;

        setIsLoadingModalDelete(true);
        try {
            await categoryAPI.delete(categorySelected.id);
            setShowModalDelete(false);
            HallAppToast.success();
            findAllCategories();
        } catch (_) {
            HallAppToast.genericError();
        } finally {
            setIsLoadingModalDelete(false);
        }
    }

    function getQtdServices(data) {
        return (
            (Array.isArray(data?.services) ? data.services.length : null) ??
            data?.servicesCount ??
            data?.countServices ??
            data?.qtdServices ??
            0
        );
    }

    return (
        <div>
            <Row style={{ margin: 0, paddingTop: "20px" }}>
                {isLoading ? (
                    <Col xs={12}>
                        <HallAppCenterContainer>
                            <AppLoading />
                        </HallAppCenterContainer>
                    </Col>
                ) : (
                    <>
                        <MenuTitle title="Categorias" showArrowInfo={false} />

                        <Form>
                            <AppInput label="Pesquisar" name="search" errors={[]} onChange={(e) => search(e.target.value)} />
                        </Form>

                        <hr />

                        <PullToRefresh onRefresh={findAllCategories}>
                            <Row style={{ margin: 0, width: "100%" }}>
                                {categoriesTmp.length === 0 ? (
                                    <EmptyState
                                        title="Nenhuma categoria cadastrada"
                                        description="Crie categorias como Cabelo, Maquiagem e Manicure para organizar seus serviços."
                                        actionLabel="Cadastrar categoria"
                                        onAction={() => setShowModalCategory(true)}
                                        icon={<FontAwesomeIcon icon={faTags} />}
                                    />
                                ) : (
                                    categoriesTmp.map((data) => {
                                        const qtd = getQtdServices(data);

                                        return (
                                            <Col xs={12} sm={12} md={6} lg={4} key={data.id} style={{ marginBottom: "10px" }}>
                                                <CustomCard>
                                                    <div className="categories-miniCard">
                                                        <div className="categories-miniCard__top">
                                                            <div className="categories-miniCard__pic">
                                                                <img src={data.logo || noImg} alt="logotipo" />
                                                            </div>

                                                            <div className="categories-miniCard__titleWrap">
                                                                <div className="categories-miniCard__name">{data.name}</div>

                                                                <div className="categories-miniCard__qtd">
                                                                    QTD:{" "}
                                                                    <strong>
                                                                        {(
                                                                            (Array.isArray(data?.services) ? data.services.length : null) ??
                                                                            data?.servicesCount ??
                                                                            data?.countServices ??
                                                                            data?.qtdServices ??
                                                                            0
                                                                        )}
                                                                    </strong>{" "}
                                                                    serviços
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="categories-miniCard__actions">
                                                            <AppButton
                                                                type="button"
                                                                width="100%"
                                                                name="Editar"
                                                                variant="secondary"
                                                                className="mb-0"
                                                                onClick={() => {
                                                                    setCategorySelected(data);
                                                                    setShowModalCategory(true);
                                                                }}
                                                            />

                                                            <AppButton
                                                                type="button"
                                                                width="100%"
                                                                name="Excluir"
                                                                variant="danger"
                                                                className="mb-0"
                                                                onClick={() => {
                                                                    setCategorySelected(data);
                                                                    setShowModalDelete(true);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </CustomCard>

                                            </Col>
                                        );
                                    })
                                )}
                            </Row>
                        </PullToRefresh>
                    </>
                )}
            </Row>

            <ConfirmModal
                show={showModalDelete}
                title="Excluir"
                isLoading={isLoadingModalDelete}
                confirm={executeDeletion}
                closeModal={() => {
                    setCategorySelected({});
                    setShowModalDelete(false);
                }}
            >
                Deseja remover a categoria <span style={{ fontWeight: "bold" }}>{categorySelected?.name}</span>?
                <br />
                <span style={{ fontWeight: "bold" }}>
                    Ao remover a categoria, todos os serviços vinculados a essa categoria serão removidos!
                </span>
            </ConfirmModal>

            <FloatingButton
                icon={faAdd}
                onClick={() => {
                    setCategorySelected({});
                    setShowModalCategory(true);
                }}
            />

            {showModalCategory && (
                <ModalCategory
                    categorySelected={categorySelected}
                    findAllCategories={findAllCategories}
                    show={showModalCategory}
                    closeShow={() => {
                        setCategorySelected({});
                        setShowModalCategory(false);
                    }}
                />
            )}
        </div>
    );
}

export default Categories;
